import { EdgelessDefaultToolButton } from './quick-tool/default-tool-button';

export function effects() {
  customElements.define(
    'edgeless-default-tool-button',
    EdgelessDefaultToolButton
  );
}
